/* Major 9 Radio — speelt 30-seconden-fragmenten (via Apple Music) van platen uit de winkel. */
(function () {
  'use strict';
  /* Altijd maar één geluid tegelijk: start er iets, dan stopt de rest (radio én fragmentknoppen) */
  (function () {
    if (HTMLMediaElement.prototype.play.__m9) return;
    var live = window.__m9live = window.__m9live || new Set(), orig = HTMLMediaElement.prototype.play;
    var patched = function () {
      var me = this;
      live.forEach(function (m) { if (m !== me && !m.paused) { try { m.pause(); } catch (e) {} } });
      live.add(me);
      try { window.dispatchEvent(new CustomEvent('m9:play', { detail: me })); } catch (e) {}
      return orig.apply(this, arguments);
    };
    patched.__m9 = true;
    HTMLMediaElement.prototype.play = patched;
  })();
  /* Muziekzoeker met twee bronnen: eerst Apple Music, lukt dat niet (bijv. te veel zoekopdrachten vanaf één telefoon) dan Deezer.
     Geeft altijd dezelfde vorm terug: { previewUrl, trackName, artistName, collectionName, trackTimeMillis, trackId } */
  window.M9find = function (artist, album) {
    var term = (artist + ' ' + album).trim();
    function withTimeout(p, ms) { return Promise.race([p, new Promise(function (r) { setTimeout(function () { r(null); }, ms); })]); }
    var itunes = withTimeout(fetch('https://itunes.apple.com/search?term=' + encodeURIComponent(term) + '&media=music&entity=song&limit=50&country=NL')
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }), 6000)
      .then(function (d) { return d && d.results ? d.results.filter(function (r) { return r.previewUrl; }) : null; });
    function deezer() {
      return withTimeout(new Promise(function (res) {
        var n = 'm9dz' + Math.random().toString(36).slice(2), s = document.createElement('script');
        window[n] = function (d) { res(d); try { delete window[n]; } catch (e) {} s.remove(); };
        s.onerror = function () { res(null); };
        s.src = 'https://api.deezer.com/search?q=' + encodeURIComponent(term) + '&limit=50&output=jsonp&callback=' + n;
        document.head.appendChild(s);
      }), 6000).then(function (d) {
        return ((d && d.data) || []).filter(function (x) { return x.preview; }).map(function (x) {
          return { previewUrl: x.preview, trackName: x.title, artistName: x.artist && x.artist.name, collectionName: x.album && x.album.title, trackTimeMillis: (x.duration || 0) * 1000, trackId: 'dz' + x.id };
        });
      });
    }
    return itunes.then(function (list) { return list && list.length ? list : deezer(); }).catch(function () { return deezer(); });
  };
  var box, audio, queue = [], qi = -1, state = { on: false, genre: 'alle-vinyl', repeat: false, handle: null }, current = null, busy = false, played = {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function save() { try { sessionStorage.setItem('m9-radio', JSON.stringify(state)); } catch (e) {} }
  function load() { try { var s = JSON.parse(sessionStorage.getItem('m9-radio') || 'null'); if (s) state = Object.assign(state, s); } catch (e) {} }
  function norm(x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\(.*?\)|\[.*?\]/g, '').replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function money(c) { return '€' + (c / 1).toFixed(2).replace('.', ','); }
  function jsonp(url) {
    return new Promise(function (res) {
      var n = 'm9r' + Math.random().toString(36).slice(2), s = document.createElement('script'), done = false;
      window[n] = function (d) { done = true; res(d); try { delete window[n]; } catch (e) {} s.remove(); };
      s.onerror = function () { if (!done) res(null); };
      s.src = url + '&callback=' + n; document.head.appendChild(s);
      setTimeout(function () { if (!done) res(null); }, 7000);
    });
  }
  // Een fractie stilte (WAV, 16-bit) om het geluid binnen een tik te ontgrendelen; wordt hier gemaakt i.p.v. als lange tekst meegestuurd
  var SILENT = window.M9_SILENT = (function () {
    var sr = 22050, n = 1764, len = 44 + n * 2, s = '';
    function u32(x) { return String.fromCharCode(x & 255, (x >> 8) & 255, (x >> 16) & 255, (x >> 24) & 255); }
    function u16(x) { return String.fromCharCode(x & 255, (x >> 8) & 255); }
    s = 'RIFF' + u32(len - 8) + 'WAVEfmt ' + u32(16) + u16(1) + u16(1) + u32(sr) + u32(sr * 2) + u16(2) + u16(16) + 'data' + u32(n * 2);
    for (var i = 0; i < n * 2; i++) s += String.fromCharCode(0);
    return 'data:audio/wav;base64,' + btoa(s);
  })();
  function isSilent() { return !audio.src || audio.src.indexOf('data:') === 0; }
  /* Mobiel (iOS/Android) staat afspelen alleen toe binnen de tik zelf: ontgrendel het geluid meteen bij de klik */
  function unlock() {
    if (audio.__u) return;
    if (!audio.paused || (audio.src && !isSilent())) return;
    audio.__u = true;
    audio.src = SILENT;
    var p = audio.play(); if (p && p.then) p.then(function () { if (isSilent()) audio.pause(); }).catch(function () {});
  }
  var fadeRaf = null, fadingOut = false;
  function fade(to, ms, cb) {
    clearTimeout(fadeRaf);
    var from = audio.volume, t0 = performance.now();
    (function step(t) {
      var k = Math.min(1, (t - t0) / Math.max(ms, 1));
      var e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      try { audio.volume = Math.max(0, Math.min(1, from + (to - from) * e)); } catch (er) {}
      if (k < 1) fadeRaf = setTimeout(function () { step(performance.now()); }, 30); else if (cb) cb();
    })(t0);
  }
  var yielded = null, userAct = 0;
  function otherPlaying() { var o = null; (window.__m9live || new Set()).forEach(function (m) { if (m !== audio && !m.paused && !m.ended) o = m; }); return o; }
  function yieldTo(o) {
    if (yielded === o) return;
    yielded = o;
    var back = function (e) {
      if (o.src && o.src.indexOf('data:') === 0) return;
      if (e && e.type === 'pause' && !o.ended) { setTimeout(function () { if (o.paused && !o.ended && yielded === o) { yielded = null; } }, 600); return; }
      o.removeEventListener('pause', back); o.removeEventListener('ended', back);
      if (yielded !== o) return; yielded = null;
      setTimeout(function () { if (state.on && !otherPlaying() && audio.src && audio.paused) playIn().catch(function () {}); }, 400);
    };
    o.addEventListener('pause', back); o.addEventListener('ended', back);
  }
  function playIn() {
    var o = otherPlaying();
    if (o && Date.now() - userAct > 8000) { yieldTo(o); ui(false); return Promise.resolve(); }
    fadingOut = false;
    try { audio.volume = 0; } catch (e) {}
    return audio.play().then(function () { fade(1, 1800); ui(true); });
  }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function loadQueue() {
    var all = [];
    function page(n) {
      return fetch('/collections/' + state.genre + '?view=radio&page=' + n).then(function (r) { return r.ok ? r.text() : ''; }).then(function (txt) {
        var d; try { d = JSON.parse(txt); } catch (e) { d = null; }
        if (!d) return n === 1 ? fallback() : null;
        (d.products || []).forEach(function (p) { if (p.variants && p.variants.some(function (v) { return v.available; })) all.push(p); });
        if (n < (d.pages || 1) && n < 15) return page(n + 1);
      });
    }
    function fallback() {
      return fetch('/collections/' + state.genre + '/products.json?limit=250').then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) {
        (d.products || []).forEach(function (p) { if (p.variants && p.variants.some(function (v) { return v.available; })) all.push(p); });
      }).catch(function () {});
    }
    return page(1).catch(function () {}).then(function () {
      // platen met een opgeslagen fragment eerst: die spelen direct en betrouwbaar (ook op iPhone)
      var withPv = shuffle(all.filter(function (p) { return p.pv && p.pv.length; })), rest = shuffle(all.filter(function (p) { return !(p.pv && p.pv.length); }));
      queue = withPv.concat(rest); qi = -1;
    });
  }
  function storedTrack(p) {
    if (!p.pv || !p.pv.length) return null;
    var opts = p.pv.filter(function (x) { return !played[x.u]; }); if (!opts.length) opts = p.pv;
    var x = opts[Math.floor(Math.random() * opts.length)];
    return { previewUrl: x.u, trackName: x.t, trackId: x.u };
  }
  function ui(playing) {
    box.classList.toggle('is-playing', !!playing);
    var st = $('[data-radio-state]', box); if (st) st.textContent = playing ? 'Speelt nu' : 'Gepauzeerd';
    var t = $('[data-radio-toggle]', box); t.setAttribute('aria-label', playing ? 'Pauze' : 'Afspelen');
    $$('[data-radio-open]').forEach(function (b) { b.classList.toggle('is-on', state.on); b.setAttribute('aria-pressed', state.on ? 'true' : 'false'); });
    var rp = $('[data-radio-repeat]', box); rp.setAttribute('aria-pressed', state.repeat ? 'true' : 'false'); rp.classList.toggle('is-on', state.repeat);
  }
  function show(p, tr) {
    var parts = p.title.split(' - '), artist = parts.length > 1 ? parts[0] : p.vendor, album = parts.length > 1 ? parts.slice(1).join(' - ') : p.title;
    $('[data-radio-track]', box).textContent = tr ? tr.trackName : album;
    $('[data-radio-sub]', box).textContent = artist + ' · ' + album;
    var img = $('[data-radio-img]', box); img.src = (p.images && p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=120' : (tr && tr.artworkUrl100) || '');
    $$('[data-radio-link]', box).forEach(function (a) { a.href = '/products/' + p.handle; });
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    var f = $('[data-radio-form]', box), view = $('[data-radio-view]', box);
    if (v && p.variants.length === 1 && parseFloat(v.price) > 0) { f.hidden = false; view.hidden = true; $('[data-radio-variant]', box).value = v.id; $('[data-radio-price]', box).textContent = money(parseFloat(v.price)); }
    else { f.hidden = true; view.hidden = false; }
  }
  function findTrack(p) {
    var st = storedTrack(p); if (st) return Promise.resolve(st);
    var parts = p.title.split(' - '), artist = parts.length > 1 ? parts[0] : p.vendor, album = parts.length > 1 ? parts.slice(1).join(' - ') : p.title;
    var a1 = norm(artist.split(/,|&| and | feat/i)[0]).split(' ')[0], al = norm(album);
    return window.M9find(artist, album).then(function (list) {
      var res = (list || []).filter(function (r) { return r.previewUrl && norm(r.artistName).indexOf(a1) > -1; });
      var exact = res.filter(function (r) { var c = norm(r.collectionName); return c && al && (c.indexOf(al) > -1 || al.indexOf(c) > -1); });
      var pool = (exact.length ? exact : []).filter(function (r) { return (r.trackTimeMillis || 0) > 90000 && !/intro|interlude|skit|outro/i.test(r.trackName) && !played[r.trackId]; });
      if (!pool.length) pool = exact;
      return pool.length ? pool[Math.floor(Math.random() * Math.min(pool.length, 8))] : null;
    });
  }
  var gen = 0;
  function next(tries) {
    tries = tries || 0;
    if (!tries && ready) { fadingOut = false; busy = false; playReady(); return; }
    if (busy && !tries) return;
    if (!tries && audio && !audio.paused && audio.src && !fadingOut) { fadingOut = true; busy = true; fade(0, 700, function () { audio.pause(); busy = false; next(1); }); return; }
    busy = true;
    var my = ++gen;
    if (!queue.length) { busy = false; return; }
    qi = (qi + 1) % queue.length;
    var p = queue[qi];
    show(p, null); $('[data-radio-track]', box).textContent = 'Even zoeken…';
    findTrack(p).then(function (tr) {
      if (my !== gen) return;
      if (!tr) { if (tries < 8) { busy = true; return next(tries + 1); } busy = false; $('[data-radio-track]', box).textContent = 'Geen fragment gevonden'; return; }
      played[tr.trackId] = 1; current = { p: p, tr: tr }; state.handle = p.handle; save();
      show(p, tr);
      audio.src = tr.previewUrl;
      playIn().catch(function () { ui(false); });
      busy = false;
      setTimeout(prefetchNext, 1500);
    });
  }
  var ready = null, preparing = null;
  // Zoek het eerste nummer alvast op, zodat een tik op Radio meteen kan spelen (iPhone staat afspelen alleen binnen de tik toe)
  function prepare() { if (!state.on) prefetchNext(); }
  // Zoek het volgende nummer alvast op, zodat 'volgende' en het automatisch doorgaan direct kunnen spelen
  function prefetchNext() {
    if (ready || preparing) return;
    var g = state.genre;
    preparing = (queue.length ? Promise.resolve() : loadQueue()).then(function () {
      var tries = 0;
      function attempt() {
        if (!queue.length || tries > 8) return null;
        var i = (qi + 1 + tries) % queue.length, p = queue[i]; tries++;
        return findTrack(p).then(function (tr) { if (g !== state.genre) return null; if (tr) { ready = { p: p, tr: tr, i: i }; return ready; } return attempt(); });
      }
      return attempt();
    }).catch(function () {}).then(function () { preparing = null; });
  }
  function playReady() {
    var r = ready; ready = null; gen++;
    qi = r.i; played[r.tr.trackId] = 1; current = { p: r.p, tr: r.tr }; state.handle = r.p.handle; save();
    show(r.p, r.tr);
    audio.src = r.tr.previewUrl;
    playIn().catch(function () { ui(false); $('[data-radio-track]', box).textContent = 'Tik op afspelen'; });
    setTimeout(prefetchNext, 1500);
  }
  function start() {
    try { history.replaceState(Object.assign({}, history.state || {}, { m9soft: true }), ''); } catch (e) {}
    state.on = true; save(); box.hidden = false; document.body.classList.add('has-radio');
    if (ready) { playReady(); return; }
    unlock();
    if (!queue.length) loadQueue().then(function () { next(); }); else next();
  }
  function stop() {
    state.on = false; save(); clearTimeout(fadeRaf); audio.pause(); box.hidden = true; document.body.classList.remove('has-radio'); ui(false);
    // Safari opnieuw laten tekenen zodat er geen leeg vlak blijft staan
    void document.body.offsetHeight; requestAnimationFrame(function () { window.scrollBy(0, 1); window.scrollBy(0, -1); });
  }
  function init() {
    box = $('[data-radio]'); if (!box) return;
    audio = new Audio(); audio.preload = 'none';
    load();
    $('[data-radio-genre]', box).value = state.genre;
    if (state.min) { box.classList.add('is-min'); var mb0 = $('[data-radio-min]', box); if (mb0) { mb0.setAttribute('aria-expanded', 'false'); mb0.setAttribute('aria-label', 'Radio groter maken'); } }
    (function () {
      var sel = $('[data-radio-genre]', box), btn = $('[data-rsel-btn]', box), list = $('[data-rsel-list]', box), lab = $('[data-rsel-label]', box);
      if (!btn || !list) return;
      function paint() {
        var cur = sel.options[sel.selectedIndex]; lab.textContent = cur ? cur.text : '';
        list.innerHTML = '';
        Array.prototype.forEach.call(sel.options, function (o) {
          var li = document.createElement('li'); li.setAttribute('role', 'option'); li.setAttribute('aria-selected', o.value === sel.value ? 'true' : 'false');
          li.className = 'rsel__opt' + (o.value === 'new-picks' ? ' rsel__opt--new' : '');
          li.setAttribute('data-v', o.value); li.tabIndex = 0; li.textContent = o.text; list.appendChild(li);
        });
      }
      function open(v) { list.hidden = !v; btn.setAttribute('aria-expanded', v ? 'true' : 'false'); }
      paint();
      btn.addEventListener('click', function (e) { e.stopPropagation(); open(list.hidden); });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('[data-v]'); if (!li) return;
        e.stopPropagation(); open(false);
        if (sel.value !== li.getAttribute('data-v')) { sel.value = li.getAttribute('data-v'); sel.dispatchEvent(new Event('change')); }
        paint();
      });
      list.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.target.click(); } if (e.key === 'Escape') { open(false); btn.focus(); } });
      document.addEventListener('click', function (e) { if (!list.hidden && !e.target.closest('[data-rsel]')) open(false); });
    })();
    audio.addEventListener('ended', function () { if (isSilent()) return; if (state.repeat) { audio.currentTime = 0; playIn(); } else { fadingOut = false; if (ready) playReady(); else next(1); } });
    audio.addEventListener('timeupdate', function () { if (isSilent()) return;
      var b = $('[data-radio-progress]', box); if (audio.duration) b.style.width = (audio.currentTime / audio.duration * 100) + '%';
      var left = audio.duration - audio.currentTime;
      if (audio.duration && left < 2.5 && !fadingOut) { fadingOut = true; fade(0, left * 1000); }
    });
    audio.addEventListener('pause', function () { ui(false); });
    window.addEventListener('m9:play', function (e) { var o = e.detail; if (o === audio || !state.on) return; clearTimeout(fadeRaf); if (!audio.paused) audio.pause(); yieldTo(o); });
    audio.addEventListener('play', function () { ui(true); });
    /* iPhone: uitzetten direct bij het loslaten van de vinger, zodat de tik nooit verloren gaat */
    function offTap(e) { var x = e.target && e.target.closest && e.target.closest('[data-radio-close],[data-radio-stop]'); if (!x) return; if (e.cancelable) e.preventDefault(); userAct = Date.now(); yielded = null; stop(); }
    document.addEventListener('touchend', offTap, { passive: false });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-radio-stop]')) { e.preventDefault(); stop(); return; }
      if (e.target.closest('[data-radio-open]')) { e.preventDefault(); userAct = Date.now(); yielded = null; if (state.on && !box.hidden) { if (audio.paused) { if (audio.src && !isSilent()) playIn(); else { unlock(); next(); } } else stop(); } else start(); return; }
      if (!box.contains(e.target)) return;
      userAct = Date.now(); yielded = null;
      if (e.target.closest('[data-radio-next]') || (e.target.closest('[data-radio-toggle]') && (!audio.src || isSilent()))) unlock();
      if (e.target.closest('[data-radio-toggle]')) { if (audio.paused) { if (audio.src && !isSilent()) playIn(); else next(); } else fade(0, 500, function () { audio.pause(); }); }
      if (e.target.closest('[data-radio-next]')) next();
      if (e.target.closest('[data-radio-min]')) { state.min = !box.classList.contains('is-min'); save(); box.classList.toggle('is-min', state.min); var mb = $('[data-radio-min]', box); mb.setAttribute('aria-expanded', state.min ? 'false' : 'true'); mb.setAttribute('aria-label', state.min ? 'Radio groter maken' : 'Radio verkleinen'); return; }
      if (e.target.closest('[data-radio-repeat]')) { state.repeat = !state.repeat; save(); ui(!audio.paused); }
      if (e.target.closest('[data-radio-close]')) stop();
    });
    $('[data-radio-genre]', box).addEventListener('change', function (e) { state.genre = e.target.value; save(); queue = []; ready = null; audio.pause(); loadQueue().then(function () { next(); }); });
    /* Na het wisselen van pagina: radio weer tonen en proberen verder te spelen */
    if (state.on) { box.hidden = false; document.body.classList.add('has-radio'); loadQueue().then(function () { next(); }); }
    else if (window.matchMedia && matchMedia('(pointer: coarse)').matches) { setTimeout(prepare, 1500); }
    ui(false);
  }
  /* Doorspelen tijdens het klikken: zolang de radio aan staat laden we nieuwe pagina's zonder te herladen */
  var navBusy = false;
  function sameSite(a) {
    if (!a || a.target && a.target !== '_self' || a.hasAttribute('download')) return false;
    var u; try { u = new URL(a.href, location.href); } catch (e) { return false; }
    if (u.origin !== location.origin) return false;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return false;
    if (/^\/(cart|checkout|checkouts|account|apps|tools|admin|services|password)/.test(u.pathname)) return false;
    if (/\.(jpg|png|pdf|zip|xml|json)$/i.test(u.pathname)) return false;
    return u;
  }
  function runScripts(root) {
    $$('script', root).forEach(function (old) {
      var sc = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (at) { sc.setAttribute(at.name, at.value); });
      sc.text = old.textContent;
      old.parentNode.replaceChild(sc, old);
    });
  }
  function softNav(url, push) {
    if (navBusy) return;
    navBusy = true;
    var main = $('#main'); if (main) main.style.opacity = '.4';
    fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok || (r.redirected && new URL(r.url).origin !== location.origin)) throw new Error('nav');
      return r.text().then(function (h) { return { h: h, u: r.url }; });
    }).then(function (res) {
      var d = new DOMParser().parseFromString(res.h, 'text/html');
      var nm = d.getElementById('main');
      if (!nm || !main) throw new Error('nav');
      document.title = d.title;
      document.body.className = d.body.className + (state.on ? ' has-radio' : '');
      main.innerHTML = nm.innerHTML;
      var hdr = d.querySelector('.hdr .nav'), cur = $('.hdr .nav'); if (hdr && cur) cur.innerHTML = hdr.innerHTML;
      runScripts(main);
      if (push !== false) history.pushState({ m9soft: true }, '', url);
      var hash = new URL(url, location.href).hash;
      if (hash && document.querySelector(hash)) document.querySelector(hash).scrollIntoView(); else window.scrollTo(0, 0);
      main.style.opacity = '';
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
      navBusy = false;
    }).catch(function () { location.href = url; });
  }
  document.addEventListener('click', function (e) {
    if (!state.on || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]'); if (!a || a.closest('[data-no-soft]')) return;
    var u = sameSite(a); if (!u) return;
    e.preventDefault();
    var d = a.closest('.drawer.is-open'); if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-locked'); }
    var srch = $('#Search.is-open'); if (srch) { srch.classList.remove('is-open'); document.body.classList.remove('is-locked'); }
    softNav(u.href, true);
  });
  window.addEventListener('popstate', function (e) { if (state.on && e.state && e.state.m9soft) softNav(location.href, false); });
  if (state.on) { try { history.replaceState(Object.assign({}, history.state || {}, { m9soft: true }), ''); } catch (e) {} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
